/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Duration_RequiredInputs */

const vi_irrigation_run_duration_required = /** @type {(inputs: Irrigation_Run_Duration_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập thời lượng tưới, ít nhất 1 phút`)
};

/**

* @param {Irrigation_Run_Duration_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_duration_required = /** @type {((inputs?: Irrigation_Run_Duration_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Duration_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_duration_required(inputs)
});